export default __webpack_public_path__ + "static/media/profile.61175757.svg";